
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"distribuir"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idCobranza"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"porcentajeDistribucion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"simular"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribuir"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idCobranza"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idCobranza"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"porcentajeDistribucion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"porcentajeDistribucion"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"simular"},"value":{"kind":"Variable","name":{"kind":"Name","value":"simular"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facturasDeudor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cobranza"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dniDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoCobrado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaCobranza"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"deuda"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dniDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreDeudor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"monto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoFacturable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoNoFacturable"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"facturasDistribuidas"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cobranza"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dniDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoCobrado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaCobranza"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"deuda"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dniDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreDeudor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"monto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoFacturable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoNoFacturable"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"porcentajeDistribucion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoPorDistribuir"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoDeudor"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1072}};
    doc.loc.source = {"body":"mutation distribuir($idCobranza:ID!, $porcentajeDistribucion: Int!, $simular: Boolean ){\n    distribuir(input: {idCobranza: $idCobranza, porcentajeDistribucion: $porcentajeDistribucion, simular: $simular}){\n        facturasDeudor{\n            cobranza{\n                id\n                dniDeudor\n                nombreDeudor\n                montoCobrado\n                fechaCobranza\n            }\n            deuda{\n                id\n                dniDeudor\n                nombreDeudor\n            }\n            monto\n            montoFacturable\n            montoNoFacturable\n        }\n        facturasDistribuidas{\n            cobranza{\n                id\n                dniDeudor\n                nombreDeudor\n                montoCobrado\n                fechaCobranza\n            }\n            deuda{\n                id\n                dniDeudor\n                nombreDeudor\n            }\n            monto\n            montoFacturable\n            montoNoFacturable\n        }\n        porcentajeDistribucion\n        montoPorDistribuir\n        montoDeudor\n    }\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["distribuir"] = oneQuery(doc, "distribuir");
        
